"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(_ref) {
  var children = _ref.children,
      look = _ref.look,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var classes = ['shx-card', className];

  if (look === 'border') {
    classes.push('shx-card--border');
  }

  var CardFragment = _react.default.createElement(tag, {
    className: classes.join(' ')
  }, children);

  return CardFragment;
};

Card.propTypes = {
  children: _propTypes.default.node,
  look: _propTypes.default.oneOf(['border']),
  tag: _propTypes.default.string
};
var _default = Card;
exports.default = _default;